import { useEffect } from "react";
import { MessageCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const STORAGE_KEY = "acex.chatButtonPos";

export default function ChatLauncher({
  unread,
  onClick,
}: {
  unread: number;
  onClick: () => void;
}) {
  // Remove any stale dragged position so the button always anchors bottom-right.
  useEffect(() => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      // ignore
    }
  }, []);

  return (
    <button
      onClick={onClick}
      className="fixed bottom-[calc(5rem+env(safe-area-inset-bottom))] right-4 sm:bottom-6 sm:right-6 z-40 h-14 w-14 rounded-full bg-primary text-primary-foreground shadow-lg hover:shadow-xl transition-shadow flex items-center justify-center"
      aria-label="Open live chat"
    >
      <MessageCircle className="h-6 w-6 pointer-events-none" />
      {unread > 0 && (
        <Badge className="absolute -top-1 -right-1 h-5 w-5 p-0 flex items-center justify-center text-[10px] bg-destructive text-destructive-foreground pointer-events-none">
          {unread}
        </Badge>
      )}
    </button>
  );
}
